import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Faq() {
  const revealRef = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo accedo al ebook después de comprar?',
    a: 'Recibes un email de confirmación con el enlace de descarga inmediata. En menos de 2 minutos tienes el PDF en tu dispositivo, listo para leer.'
  }, {
    q: '¿Qué formas de pago aceptan?',
    a: 'Aceptamos tarjeta de crédito, débito, PayPal y transferencia bancaria. El pago es procesado con cifrado SSL de 256 bits.'
  }, {
    q: '¿Necesito experiencia previa en cocina para aplicar el método?',
    a: 'No. El Método Italiano™ fue diseñado para personas sin formación culinaria. Cada paso está explicado con fotos, tiempos exactos y notas de error comunes.'
  }, {
    q: '¿Funciona para alguien con celiaquía diagnosticada?',
    a: 'Sí. Todas las recetas fueron desarrolladas y probadas con personas celiacas. Las harinas utilizadas son naturalmente libres de gluten, no procesadas en instalaciones compartidas.'
  }, {
    q: '¿Cuánto tiempo tengo acceso al ebook?',
    a: 'Acceso de por vida. Una sola compra y el ebook es tuyo para siempre. Además, si sacamos una versión actualizada, te notificamos sin costo adicional.'
  }, {
    q: '¿Las harinas que necesito son fáciles de conseguir?',
    a: 'Sí. Todas las harinas y almidones del método están disponibles en supermercados convencionales, tiendas naturistas o Amazon. No hay ingredientes exóticos ni importados.'
  }, {
    q: '¿Hay soporte si tengo dudas al aplicar las recetas?',
    a: 'Sí. El Bono 3 incluye acceso a la comunidad privada donde Hugo Otero responde personalmente. No te quedas solo con el PDF.'
  }, {
    q: '¿El precio de $12 es permanente?',
    a: 'No. Este es el precio de lanzamiento. Una vez que cerremos esta etapa, el precio vuelve a su valor normal de $120. No hay fecha exacta de cierre.'
  }, {
    q: '¿Puedo imprimir el ebook?',
    a: 'Sí, el PDF está optimizado para impresión. Puedes tenerlo en papel en la cocina si lo prefieres al formato digital.'
  }, {
    q: '¿Qué pasa si compro y no me gusta?',
    a: 'Tienes 7 días de garantía total. Si no estás satisfecho por cualquier motivo, devolvemos el 100% de tu dinero sin preguntas. Sin formularios complicados, sin demoras.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="bg-gris-oscuro py-14 sm:py-[90px] px-6" data-id="element-169">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-170">
        <div className="text-center" data-id="element-171">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-172">
            Resolvemos tus dudas
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-173">
            Preguntas frecuentes
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-174"></div>
        </div>

        <div className="mt-12 max-w-[760px] mx-auto" data-id="element-175">
          {faqs.map((faq, index) => <div key={index} className={`faq-item border-b border-white/5 overflow-hidden ${openIndex === index ? 'open' : ''}`} data-id="element-176">
              <button className="w-full bg-transparent border-none text-white font-poppins text-[15px] font-semibold text-left py-5 pr-12 relative block leading-[1.5] cursor-pointer" onClick={() => toggleFaq(index)} data-id="element-177">
                {faq.q}
                <span className={`absolute right-0 top-1/2 -translate-y-1/2 text-oro text-[24px] font-light transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-178">
                  +
                </span>
              </button>
              <div className="faq-answer text-[14px] text-white/65 leading-[1.8]" data-id="element-179">
                {faq.a}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}